import {PatientAdditionalNameSerializer} from '../@core/api.service';
import {PATIENT_NAME_USE_TYPES} from '../@core/patient_name_use_types';
import {SimpleDatePipe} from '../@theme/pipes/simple-date.pipe';
import {GetterCache} from '../utils/accessor.utils';

export class AdditionalName implements PatientAdditionalNameSerializer {
    id: number;
    patient: number;
    use?: string;
    qualifier?: string;
    first_name?: string;
    middle_name?: string;
    last_name?: string;
    prefix?: string;
    suffix?: string;
    start?: Date | string;
    end?: Date | string;

    readonly useTypes = PATIENT_NAME_USE_TYPES;

    constructor(private data: PatientAdditionalNameSerializer) {
        Object.assign(this, data);
    }

    @GetterCache()
    get displayUse(): string {
        return this.useTypes[this.use] || this.use;
    }

    @GetterCache()
    get displayDateRange(): string {
        const startDate = SimpleDatePipe.transform(this.end);
        const endDate = SimpleDatePipe.transform(this.start);
        if (startDate && endDate) {
            return `${startDate} - ${endDate}`;
        } else if (startDate) {
            return startDate;
        } else if (endDate) {
            return endDate;
        }
        return '';
    }
}
